import ArticleLayout from "@/components/feature/ArticleLayout";

export default function BudgetArticle() {
  return <ArticleLayout slug="pandabuy-sheet-budget-finds" />;
}